import React, { forwardRef } from 'react';
import * as PIXI from 'pixi.js';
import { ASSET_NAME } from '../../assets';
import { Sprite } from '@pixi/react';

const BasicTexture = forwardRef(
  ({
    width,
    height,
    textureName,
    zIndex = 2,
    x = 0,
    y = 0,
    anchor = 0.5,
  }, ref) => {
    const texture = PIXI.Assets.get(ASSET_NAME[textureName]);
    if (!texture) return null;

    return (
      <Sprite
        ref={ref} // Forward the ref to the Sprite
        texture={texture}
        anchor={anchor}
        width={width}
        height={height}
        zIndex={zIndex}
        x={x}
        y={y}
      />
    );
  },
);

export default BasicTexture;
